import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Explore from "@/components/Explore";
import CoreMessage from "@/components/CoreMessage";
import InnerWork from "@/components/InnerWork";
import Energy from "@/components/Energy";
import CommunityCTA from "@/components/CommunityCTA";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#040308] text-slate-100" data-testid="the-shift-app">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Explore />
        <CoreMessage />
        <InnerWork />
        <Energy />
        <CommunityCTA />
      </main>
      <Footer />
    </div>
  );
}
